import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Select, message } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import { usePostContext } from '../../App';
import 'antd/dist/reset.css';
import './index.css';

const { TextArea } = Input;

const WriteArticle = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const location = useLocation();
  const { addPostToArchive, editPost } = usePostContext(); // 移除 loggedInUser
  
  const [isEditing, setIsEditing] = useState(false);
  const [currentPost, setCurrentPost] = useState(null);

  // 文章分类选项
  const categoryOptions = [
    { label: '技术分享', value: '技术分享' },
    { label: '生活感悟', value: '生活感悟' },
    { label: '学习笔记', value: '学习笔记' },
    { label: '随笔杂谈', value: '随笔杂谈' },
    { label: '读书笔记', value: '读书笔记' }
  ];

  // 处理编辑模式
  useEffect(() => {
    if (location.state?.post) {
      const post = location.state.post;
      setIsEditing(true);
      setCurrentPost(post);
      form.setFieldsValue({
        title: post.title,
        summary: post.summary,
        content: post.content,
        category: post.category || '技术分享', // 默认分类
        tags: Array.isArray(post.tags) ? post.tags.join(', ') : post.tags || ''
      });
    }
  }, [location.state, form]);

  const onFinish = (values) => {
    // 处理标签 - 将字符串转换为数组
    const tagsArray = values.tags ? values.tags.split(',').map(tag => tag.trim()).filter(tag => tag) : [];
    
    const post = {
      ...values,
      tags: tagsArray,
      category: values.category || '技术分享'
    };

    if (isEditing && currentPost) {
      // 编辑现有文章
      editPost(currentPost.id, post);
      message.success('文章更新成功！');
    } else {
      // 创建新文章
      addPostToArchive(post);
      message.success('文章发布成功！');
    }
    
    form.resetFields();
    navigate('/archive');
  };

  return (
    <div className="write-article-container">
      <h1 className="write-article-title">
        {isEditing ? '编辑文章' : '撰写新文章'}
      </h1>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        requiredMark="*"
        className="write-article-form"
      >
        {/* 文章标题 */}
        <Form.Item
          name="title"
          label="文章标题"
          rules={[{ required: true, message: '请输入文章标题' }]}
        >
          <Input
            placeholder="请输入文章标题"
            className="single-line-input"
          />
        </Form.Item>

        {/* 文章分类 */}
        <Form.Item
          name="category"
          label="文章分类"
          rules={[{ required: true, message: '请选择文章分类' }]}
        >
          <Select
            placeholder="选择文章分类"
            options={categoryOptions}
          />
        </Form.Item>

        {/* 文章摘要 */}
        <Form.Item
          name="summary"
          label="文章摘要"
          rules={[
            { required: true, message: '请输入文章摘要' },
            { max: 200, message: '摘要不超过200字' }
          ]}
        >
          <TextArea
            placeholder="请输入文章摘要，不超过200字"
            maxLength={200}
            autoSize={{ minRows: 3, maxRows: 5 }}
            className="multi-line-textarea"
          />
        </Form.Item>

        {/* 标签 - 多标签输入 */}
        <Form.Item
          name="tags"
          label="标签"
          help="多个标签请用逗号分隔，例如：React,JavaScript,前端开发"
        >
          <Input
            placeholder="输入标签，用逗号分隔"
            className="single-line-input"
          />
        </Form.Item>

        {/* 文章内容 */}
        <Form.Item
          name="content"
          label="文章内容 (支持Markdown语法)"
          rules={[{ required: true, message: '请输入文章内容' }]}
        >
          <TextArea
            placeholder="请使用Markdown格式输入文章内容"
            autoSize={{ minRows: 10, maxRows: 30 }}
            className="multi-line-textarea content-textarea"
          />
        </Form.Item>

        <Form.Item className="submit-btn-container">
          <Button onClick={() => navigate('/archive')} style={{ marginRight: 8 }}>
            取消
          </Button>
          <Button type="primary" htmlType="submit">
            {isEditing ? '更新文章' : '发布文章'}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default WriteArticle;
